import * as React from 'react';
import { Text } from '@amzn/storm-ui';
import styled from 'styled-components';
import { unescape } from 'html-escaper';

type AccountLabelProps = { label: string };

const AccountLabelText = styled(Text)`
  word-break: break-word;
`;

export const AccountLabel: React.FC<AccountLabelProps> = ({ label }) => {
  return <AccountLabelText size="base">{unescape(label)}</AccountLabelText>;
};
